<div
	class="ic-toggle"
	[class.disabled]="disabled"
	[class.error]="error"
	[class.has-template]="optionTemplate"
	[class.no-padding]="padding === 'none'"
>
	<label [class.has-template]="optionTemplate">
		<div class="toggle">
			<input
				#input
				class="checkbox"
				type="checkbox"
				[checked]="value"
				[class.no-padding]="padding === 'none'"
				[disabled]="disabled"
				[id]="id"
				(blur)="onTouched()"
				(change)="onChange($any($event).target.checked)"
			/>
			<span class="slider round"></span>
		</div>

		@if (!optionTemplate) {
			<ic-label [help]="help" [id]="id" [pointer]="true" [required]="required">
				{{ label }}
			</ic-label>
		} @else {
			<ng-template
				[ngTemplateOutlet]="optionTemplate"
				[ngTemplateOutletContext]="{ $implicit: value, disabled: disabled }"
			/>
		}
	</label>
	<ng-content select=".errors" />
</div>
